import { render, staticRenderFns } from "./aboutAptitude.vue?vue&type=template&id=df96f5c0&"
import script from "./aboutAptitude.vue?vue&type=script&lang=js&"
export * from "./aboutAptitude.vue?vue&type=script&lang=js&"
import style0 from "./aboutAptitude.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports